<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

// No layout: portal subdomains must NOT render the operator AppLayout shell
// (sidebar, "New Rental", etc.). A bare centered card keeps the 404 on-brand
// without leaking the operator CRM's navigation structure.
const { t } = useI18n()
</script>

<template>
  <Head><title>{{ t('portal.not_found.head_title') }}</title></Head>
  <div class="shell">
    <section class="card">
      <p class="card__code">404</p>
      <h1 class="card__title">{{ t('portal.not_found.title') }}</h1>
      <p class="card__lede">{{ t('portal.not_found.lede') }}</p>
      <a href="/login" class="card__cta">{{ t('portal.not_found.cta_login') }}</a>
    </section>
  </div>
</template>

<style scoped>
.shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: color-mix(in oklch, var(--accent) 6%, var(--bg));
  padding: max(env(safe-area-inset-top), 1rem);
}
.card {
  width: 100%; max-width: 24rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg, 12px);
  padding: 2rem 1.5rem;
  box-shadow: 0 10px 25px -10px color-mix(in oklch, var(--accent) 25%, transparent);
  text-align: center;
}
.card__code { font-size: 0.75rem; font-weight: 600; letter-spacing: 0.15em; color: var(--muted); text-transform: uppercase; margin: 0 0 0.75rem; }
.card__title { font-family: var(--font-display, var(--display)); font-size: 1.75rem; margin: 0 0 0.5rem; color: var(--ink); font-weight: 700; letter-spacing: -0.01em; }
.card__lede  { color: var(--inkSoft); margin: 0 0 1.75rem; }
.card__cta   { display: inline-block; padding: 0.55rem 1.1rem; border-radius: var(--radius-button); background: var(--accent); color: var(--accentInk); text-decoration: none; font-weight: 500; font-size: 0.9rem; }
</style>
